import React from "react";

// Models
import PlanDTO from "../../../Models/DTOs/Plan";
import { RoutePaths } from "../../../Constants/RoutePaths";
import {NavLink} from "react-router-dom";
import {formatMoney} from "../../../Helpers/Currency/Currency";
import {getOfferPercentOff, getOfferPriceQualifier, getOfferRenewalText, getResolvedOffer, isPrepaidOffer} from "../../../Helpers/BillingOffers";
import {withPromotionCode} from "../../../Helpers/PromotionCode";

interface Props {
    plans: PlanDTO[];
    disableFinalBreakpoint?: boolean;
}

const HorizontalSubscribeCTA: React.FC<Props> = ({ plans, disableFinalBreakpoint }) => {
    if (!plans || plans.length === 0) return null;

    const
        hasPromotion = plans.some((plan) => (
            !!getResolvedOffer(plan) ||
            (!plan.offerCatalogResolved && (
                plan.promotionIsActive || plan.standardDiscount?.stdPromoPrice != null
            ))
        )),
        monthlyPlan = plans.find(p => p.period === 0) ?? plans.find(p => p.title === "Truth Seeker"),
        yearlyPlan = plans.find(p => p.period === 1) ?? plans.find(p => p.title === "Game Changer");

    const renderPlan = (plan: PlanDTO) => {
        const offer = getResolvedOffer(plan);
        const
            isMonthly = plan.period === 0,
            timeLabel = isPrepaidOffer(offer) ? "Introductory offer:" : isMonthly ? "First Month:" : "First Year:",
            std = plan.offerCatalogResolved ? undefined : plan.standardDiscount,
            promo = std?.stdPromoPrice,
            discountPercent = offer
                ? getOfferPercentOff(offer) ?? 0
                : promo != null
                ? Math.round(((plan.price - promo) / plan.price) * 100)
                : 0,
            displayPrice = offer?.final_amount_minor ?? promo ?? plan.price;

        return (
            <>
                <NavLink
                    to={withPromotionCode(`${RoutePaths.SignUp[0]}?plan=${plan.title.replace(/\s+/g, "-")}`)}
                    className={`horizontal-sub-cta__plan ${offer || (!plan.offerCatalogResolved && plan.promotionIsActive) ? 'is-promo' : 'is-normal-pricing'}`}
                    key={plan.planId}
                >
                    <p className="horizontal-sub-cta__cta">
                        {discountPercent > 0 && (
                            <span className="horizontal-sub-cta__percent-discount">-{discountPercent}%</span>
                        )}
                        <span className="horizontal-sub-cta__period">{offer?.headline || timeLabel}</span>
                        <span className="horizontal-sub-cta__prices">{formatMoney(displayPrice, offer?.currency ?? plan.currency)}{isPrepaidOffer(offer) && <small> {getOfferPriceQualifier(offer)}<br/>{getOfferRenewalText(offer)}</small>}</span>
                    </p>
                </NavLink>
            </>
        );
    };


    return (
        <div className={`horizontal-sub-cta ${hasPromotion ? 'has-promo' : 'has-normal-pricing'} ${disableFinalBreakpoint ? 'ignore-desktop-breakpoint-styles' : 'use-normal-styles'}`}>
            <h2>Unlock the Full Experience:</h2>

            <div className="horizontal-sub-cta__plans-wrapper">
                {monthlyPlan && renderPlan(monthlyPlan)}
                {monthlyPlan && yearlyPlan && (<p className="horizontal-sub-cta__plan-divider">OR</p>)}
                {yearlyPlan && renderPlan(yearlyPlan)}
            </div>
        </div>
    );
};

export default HorizontalSubscribeCTA;
